module.exports = "<div style=text-align:center> Núcleo de Desenvolvimento de Sistemas - Diretoria de Tecnologia da Informação </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/layout/layout-footer-template.html
// module id = 267
// module chunks = 1